module.exports = __webpack_public_path__ + "static/media/marker.a30f29ac.png";